import Label from './Label';
import AdviceStatus from './AdviceStatus';
import { AbstractMedia } from './AbstractMedia';

export interface Checklist {
  items: ChecklistItem[];
}

interface ChecklistItem {
  advices?: Advice[];
}

export enum ChecklistSeverityEnum {
  HIGH = 'HIGH',
  LOW = 'LOW',
  NONE = 'NONE',
  OFFERED = 'OFFERED',
  PROPOSED = 'PROPOSED',
  UNDEFINED = 'UNDEFINED',
}

export interface Advice {
  accepted?: boolean;
  adviceId: string;
  adviceName: Label;
  answeredDate?: string;
  mandatory?: boolean;
  status: AdviceStatus;
  highlighted?: boolean;
  coefficient?: number;
  medias?: AbstractMedia[];
  price: number;
  discountedPrice: number;
  severity?: ChecklistSeverityEnum;
}
